var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sku"}},[_c('div',{staticClass:"groupedSaleAttrs"},[_vm._l((_vm.groupedSaleAttrs),function(ulItem,ulIndex){return _c('div',{key:ulIndex,staticClass:"ulItem"},[_c('div',{staticClass:"name",style:(_vm.ulItemStyle)},[_vm._v(_vm._s(ulItem.name))]),_c('ul',{staticClass:"liItemBox"},_vm._l((ulItem.list),function(liItem,liIndex){return _c('li',{key:liIndex,class:liItem.thumbnail ? 'liColorItem' : ['liItem', ulItem.id === liItem.id ? 'active' : ''],style:([
            liItem.thumbnail
              ? {
                  marginBottom: '35px'
                }
              : {
                  color: liItem.screen ? '' : '#ccc',
                  border: liItem.screen ? '1px solid #999' : '1px solid #e3e3e3',
                  marginBottom: '35px'
                },
            _vm.skuStyle
          ]),on:{"click":function($event){return _vm.changeListActive(ulItem, liItem, liItem.screen)}}},[(liItem.thumbnail)?_c('div',{class:['icon', ulItem.id === liItem.id ? 'active' : ''],style:([
              {
                color: liItem.screen ? '' : '#ccc',
                backgroundColor: liItem.thumbnail,
                border: '1px solid',
                borderColor: liItem.screen ? '#D0D0D0' : ''
              }
            ])}):_vm._e(),(liItem.thumbnail)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(liItem.id))]):_vm._e(),(!liItem.thumbnail)?_c('div',[_vm._v(_vm._s(liItem.id))]):_vm._e()])}),0)])}),_vm._t("moreList")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }